import { CognitoUserPool } from 'amazon-cognito-identity-js'
import { AwsCognitoConfig } from 'infra/config/aws-cognito.config'

export const makeRemoteUserPoolCognito = () =>
  new CognitoUserPool({
    ClientId: AwsCognitoConfig.APP_CLIENT_ID,
    UserPoolId: AwsCognitoConfig.USER_POOL_ID,
  })
